import React from "react";

function LocationSpotAttribute(props) {
  const { isHref = false } = props;
  return (
    <>
      <div className={props.className}>
        <img
          className="me-1"
          src={props.icon}
          height={20}
          width={20}
          alt="icon"
        />
        <h5 className="d-none d-md-inline fw-bold font-14">{props?.heading}</h5>
        {!isHref && (
          <h6 className="px-md-4 sub-heading-color font-12 my-md-2 break-line">
            {props?.label}
          </h6>
        )}
        {isHref && (
          <a
            href={props.label}
            className="ps-4 d-block  my-2
       sub-heading-color font-12 break-line"
            alt={props.label}
          >
            {props?.label}
          </a>
        )}
      </div>
    </>
  );
}

export default LocationSpotAttribute;
